(function () {
  'use strict';

  document.querySelectorAll('[data-mct-slider]').forEach(initSlider);

  function initSlider(root) {
    var slides      = Array.from(root.querySelectorAll('[data-mct-slide]'));
    var dots        = Array.from(root.querySelectorAll('[data-mct-dot]'));
    var prevBtn     = root.querySelector('[data-mct-prev]');
    var nextBtn     = root.querySelector('[data-mct-next]');
    var progressBar = root.querySelector('[data-mct-progress]');
    var counterEl   = root.querySelector('[data-mct-counter]');

    var total    = slides.length;
    var current  = 0;
    var playing  = true;
    var timer    = null;
    var INTERVAL = 6000;

    // Touch / drag state
    var dragStartX = 0;
    var dragging   = false;

    function goTo(idx) {
      slides[current].classList.remove('mct-slide--active');
      if (dots[current]) dots[current].classList.remove('mct-slider__dot--active');
      current = (idx + total) % total;
      slides[current].classList.add('mct-slide--active');
      if (dots[current]) dots[current].classList.add('mct-slider__dot--active');
      if (counterEl) counterEl.textContent = (current + 1) + '/' + total;
      restartProgress();
    }

    function startTimer() {
      clearInterval(timer);
      timer = setInterval(function () { goTo(current + 1); }, INTERVAL);
    }

    function stopAutoplay() {
      if (!playing) return;
      playing = false;
      clearInterval(timer);
      stopProgress();
    }

    function restartProgress() {
      if (!progressBar) return;
      progressBar.classList.remove('mct-slider__progress-bar--playing');
      void progressBar.offsetWidth; // force reflow to restart animation
      if (playing) progressBar.classList.add('mct-slider__progress-bar--playing');
    }

    function stopProgress() {
      if (progressBar) progressBar.classList.remove('mct-slider__progress-bar--playing');
    }

    // Stop autoplay on ANY click inside the slider
    root.addEventListener('click', function (e) {
      // Navigation controls just change slide (goTo handles it), then stop
      // CTA buttons, trust badges, everything else also stops
      if (playing) stopAutoplay();
    });

    // Arrow buttons — also handled by global click above, but goTo first
    if (prevBtn) prevBtn.addEventListener('click', function (e) {
      e.stopPropagation(); // prevent double-fire with root listener
      goTo(current - 1);
      stopAutoplay();
    });
    if (nextBtn) nextBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      goTo(current + 1);
      stopAutoplay();
    });

    // Dot buttons
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function (e) {
        e.stopPropagation();
        goTo(i);
        stopAutoplay();
      });
    });

    // Touch swipe
    root.addEventListener('touchstart', function (e) {
      dragging = true;
      dragStartX = e.touches[0].clientX;
    }, { passive: true });

    root.addEventListener('touchend', function (e) {
      if (!dragging) return;
      var dx = e.changedTouches[0].clientX - dragStartX;
      if (dx < -50) { goTo(current + 1); stopAutoplay(); }
      if (dx >  50) { goTo(current - 1); stopAutoplay(); }
      dragging = false;
    }, { passive: true });

    // Mouse drag
    root.addEventListener('mousedown', function (e) {
      dragging = true;
      dragStartX = e.clientX;
    });

    root.addEventListener('mouseup', function (e) {
      if (!dragging) return;
      var dx = e.clientX - dragStartX;
      // Only trigger slide if actual drag (not just click)
      if (Math.abs(dx) > 50) {
        if (dx < 0) goTo(current + 1);
        else        goTo(current - 1);
        stopAutoplay();
      }
      dragging = false;
    });

    // Keyboard
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { goTo(current - 1); stopAutoplay(); }
      if (e.key === 'ArrowRight') { goTo(current + 1); stopAutoplay(); }
    });

    // Init
    goTo(0);
    startTimer();
    restartProgress();
  }
})();
